import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";

import "./_Footer.scss"
import { getLabel } from "../../Services/Language/LanguageService";
import { baseLang } from "../../Lang/BaseLang";
import { ConfigContext } from "../../Context/ConfigContext/ConfigContext.js";
import { AuthContext } from "../../Context/AuthContext/AuthContext";
import { Button } from "primereact/button";
import { Sidebar } from 'primereact/sidebar';
import { classNames } from "primereact/utils";
import { changeWebConfig } from "../../API/Users/UserRequests";
import { toastShow } from "../../Services/ToastService";
import { Toast } from "primereact/toast";

import FooterComponent from '../../../Router/FooterComponent'

const Footer = () => {

    const toast = useRef(null);


    const { config, changeTheme, changeLanguage } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);
    const [showConfig, setShowConfig] = useState(false);


    // Funcion para obtener la IP de la maquina desde la API `https://geolocation-db.com/`
    const getData = async () => {
        // TODO PETICION -> FUNCION
        // const promesa = await fetch('https://geolocation-db.com/json/8dd79c70-0801-11ec-a29f-e381a788c2c0')
        // // const promesa = await fetch('https://ip4.seeip.org/json')

        // await promesa.json()

        //     .then((res) => {
        //         setIP(res.IPv4)
        //     })
        //     .catch((error) => {
        //         console.error(error);
        //         setMostrar(true)
        //     })
    }


    // UseEffect para obtener los datos de la IP
    useLayoutEffect(() => {
        getData();
    }, []);
    


    return (
        <div className="footer__Box">
            <Toast
                ref={toast}
                position="bottom-center"
            />
            <div className="footer__Container">

                <div className="d-flex align-items-center">
                    <span className={`p-menuitem-icon pi pi-fw pi-user footer_column-icon mx-2`}></span>
                    <small className="footer_column-info">  {getLabel(baseLang, 'user', config.language)}: {`${userAuth.Usuario}`}  </small><br />
                </div>

                <div className="d-flex align-items-center">
                    <span className={`p-menuitem-icon pi pi-fw pi-cog footer_column-icon mx-2`} ></span>
                    <small className="footer_column-info">{getLabel(baseLang, 'rol', config.language)}: {`${userAuth.Rol}`}</small><br />
                </div>


                <div className="d-flex align-items-center">
                    <span className={`p-menuitem-icon pi pi-fw pi-database footer_column-icon mx-2`} ></span>
                    <small className="footer_column-info">{getLabel(baseLang, 'DB', config.language)}: IPS</small>
                </div>
                <div className="d-flex align-items-center">
                    <span className={`p-menuitem-icon pi pi-fw pi-desktop footer_column-icon mx-2`} ></span>
                    <small className="footer_column-info">API: {(process.env.REACT_APP_API_URL).replace('https://were.ppf.com.hn/', '')}</small>
                </div>



            </div>
            <div className="footer_column-UserName" >
                {/* <span className={`p-menuitem-icon pi pi-fw pi-user  footer_column-icon`} style={{ marginLeft: 5 }}></span> */}
                <FooterComponent />
                {/* <small className="footer_column-info">    {`${userAuth.UserName}`}</small> */}
                {/* <div hidden={habilitar} > */}
                {/* </div> */}
                <Button
                    icon="pi pi-cog"
                    className=""
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                        setShowConfig(true);
                    }}
                    text
                // outlined
                />
            </div>
            <Sidebar visible={showConfig} onHide={() => setShowConfig(false)} position="right" baseZIndex={1000000}>
                <div className="p-d-flex p-flex-column p-ai-center">
                    <h1>{getLabel(baseLang, 'configuracion', config.language)}</h1>
                    <div>
                        <hr />
                        <h2>
                            {getLabel(baseLang, 'idioma', config.language)}
                        </h2>
                        <div className="p-d-flex p-flex-row p-ai-center">
                            <Button
                                // icon="pi pi-globe"
                                className={classNames("p-button-rounded", { "p-button-primary": config.language === 'es' })}
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    changeLanguage('es');
                                }}
                                label="Español"
                                outlined={config.language !== 'es'}
                                text={config.language !== 'es'}
                            />
                            <Button
                                // icon="pi pi-globe"
                                className={classNames("p-button-rounded", { "p-button-primary": config.language === 'en' })}
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    changeLanguage('en');
                                }}
                                label="English"
                                outlined={config.language !== 'en'}
                                text={config.language !== 'en'}
                            />
                        </div>
                    </div>
                    <div className="mt-4">
                        <hr />
                        <h2>
                            {getLabel(baseLang, 'tema', config.language)}
                        </h2>
                        <div className="p-d-flex p-flex-row p-ai-center" >
                            {/* CONFIGURACION TEMA DARK Y LIGTH */}
                            <Button
                                icon="pi pi-moon"
                                className={classNames("p-button-rounded", { "p-button-primary": config.theme === 'Dark' })}
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    changeTheme('Dark');
                                }}
                                label="Dark"
                                outlined={config.theme !== 'Dark'}
                                text={config.theme !== 'Dark'}
                            />
                            <Button
                                icon="pi pi-sun"
                                className={classNames("p-button-rounded", { "p-button-primary": config.theme === 'Light' })}
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    changeTheme('Light');
                                }}
                                label="Light"
                                outlined={config.theme !== 'Light'}
                                text={config.theme !== 'Light'}
                            />
                        </div>
                        <hr />
                    </div>
                    <div className="configSave">
                        {/* boton guardar */}
                        <Button
                            icon="pi pi-save"
                            className={classNames("p-button-rounded")}
                            onClick={async () => {
                                const u = await changeWebConfig(userAuth.idUser, config);
                                if (u.length > 0) {
                                    // signIn(u[0]);
                                    
                                    toastShow(toast, 'success', getLabel(baseLang, 'msgConfigGuardada', config.language));
                                    setShowConfig(false);
                                } else {
                                    toastShow(toast, 'error', getLabel(baseLang, 'msgErrorConfig', config.language));
                                }
                            }}
                            label={getLabel(baseLang, 'btnGuardar', config.language)}
                            // outlined
                            severity="success"
                        />
                    </div>

                </div>
            </Sidebar>
        </div>
    )
}


export default Footer;